<template>
<div class="page_member">
    <!-- 列表 -->
    <div class="jiangren" v-if="dataList.length > 0">
        <div class="con" v-for="member in dataList" :key="member.id">
            <div class="con_info">
                <img :src="member.thumb ? ( $publicData.withHttpStart(member.thumb) ? member.thumb : imageUrl+member.thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
                <div class="name">{{ member.nickname ? member.nickname : $publicData.formatPhone(member.username) }}</div>
            </div>
            <div class="time">注册时间: {{ member.created_at }}</div>
        </div>
    </div>
	<!-- 无会员 -->
	<div class="page_default" v-if="dataList.length == 0">
		<div class="bg">
			<img :src="publicPath+'statics/images/no_member.png'" alt="" class="tu">
		</div>
		<div class="tips">暂无会员</div>
	</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
            dataList: [],
			imageUrl: this.$publicData.uploadImage,
        };
    },

    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "分销商会员"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var param = {
                token: this.token
            }
            this.$api.my.agentUser(param).then(res => {
                if (res.code == 200) {
                    this.dataList = res.result
                } else {
                    this.$toast(res.message)
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
